module.exports = __webpack_public_path__ + "fonts/b3f82d90-14bc-4c20-8a10-a6b7bd0f304f.d9835df3.ttf";